import { Card, CardContent } from "../../components/ui/card";
import { Quote, User, Building, Award } from "lucide-react";

export default function GovernmentVision() {
  return (
    <section id="government-vision" className="py-20 bg-gradient-to-br from-primary/5 via-white to-accent/5">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Quote Section */}
          <Card className="border-primary/20 shadow-lg mb-12">
            <CardContent className="p-8 md:p-12">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                  <Quote className="w-8 h-8 text-white" />
                </div>

                <div className="flex-1 space-y-6">
                  <blockquote className="text-xl md:text-2xl text-foreground leading-relaxed font-medium italic">
                    "Sangli Mahanagarpalika is committed to transforming urban governance through digital innovation. This blockchain-based system ensures transparency, accountability, and efficient use of public funds."     </blockquote>


                  <div className="flex items-center space-x-4 pt-4 border-t border-border">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center">
                      <User className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-foreground">Satyam Gandhi</p>
                      <p className="text-sm text-muted-foreground">Metropolitan Commissioner & CEO</p>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          {/* Vision Cards */}
          <div className="grid md:grid-cols-3 gap-8">
            {/* Digital Transformation */}
            <Card className="border-blue-200 bg-blue-50/50 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Building className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-3">
                  Digital Governance
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Pioneering the use of cutting-edge technology to create transparent,
                  efficient, and citizen-centric governance systems across all Sangli Mahanagarpalika infrastructure operations.
                </p>
              </CardContent>
            </Card>

            {/* Smart City Mission */}
            <Card className="border-orange-200 bg-orange-50/50 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-accent rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Award className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-3">
                  Smart City Vision
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Supporting India’s Smart Cities Mission by implementing innovative
                  solutions that improve urban infrastructure planning, execution, and monitoring.
                </p>
              </CardContent>
            </Card>

            {/* Citizen Trust */}
            <Card className="border-green-200 bg-green-50/50 hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Quote className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-foreground mb-3">
                  Citizen Trust
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Building unshakeable public trust through complete transparency,
                  accountability, and fraud-proof tracking of all municipal projects — roads, gutters, and footpaths.
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Key Achievements */}
          <div className="mt-16 bg-gradient-to-r from-primary/10 to-accent/10 rounded-2xl p-8">
            <h3 className="text-2xl font-semibold text-center text-foreground mb-8">
              Leading Digital Innovation in Maharashtra
            </h3>

            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-primary mb-2">100+</div>
                <p className="text-sm text-muted-foreground">Total Projects Tracked</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent mb-2">All</div>
                <p className="text-sm text-muted-foreground">Funds Monitored</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-green-600 mb-2">100%</div>
                <p className="text-sm text-muted-foreground">Documents Digitized</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-purple-600 mb-2">24/7</div>
                <p className="text-sm text-muted-foreground">Public Access</p>
              </div>
            </div>
          </div>

          {/* Government Commitment */}
          <div className="mt-12 text-center">
            <div className="inline-flex items-center space-x-2 bg-primary/10 px-6 py-3 rounded-full">
              <Building className="w-5 h-5 text-primary" />
              <span className="text-primary font-medium">
                Committed to Digital India | Transparent Governance | Smart Cities Mission
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}